// Origem do cadastro (campanha, anúncio, indicação), enviada ao backend no
// cadastro por e-mail e no login/cadastro via Google.
//
// O site (www) grava no cookie `sa_origem` (domínio .saldoativo.com.br, visível
// aqui no app) dois blocos:
//   primeiro_toque    — primeira visita com campanha ou site externo; nunca muda.
//   ultimo_toque_pago — visita mais recente vinda de anúncio.
// Quem chega direto ao app usa os parâmetros da URL atual com a mesma regra.
// O `cta` (botão clicado no site) vem sempre da URL. Os cookies _fbc/_fbp do
// Meta Pixel vão junto para a atribuição no servidor.

const CHAVES_URL = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid', 'gclid', 'ref'];

function lerCookie(nome) {
  if (typeof document === 'undefined') return null;
  const m = document.cookie.match(new RegExp(`(?:^|; )${nome}=([^;]*)`));
  if (!m) return null;
  try {
    return decodeURIComponent(m[1]);
  } catch {
    return null;
  }
}

function ehObjeto(v) {
  return Boolean(v) && typeof v === 'object' && !Array.isArray(v);
}

function origemDoCookie() {
  try {
    const dados = JSON.parse(lerCookie('sa_origem') || 'null');
    return ehObjeto(dados) ? dados : {};
  } catch {
    return {};
  }
}

/** Mesma regra do site: clique em anúncio da Meta ou do Google. */
export function ehToquePago(toque) {
  return Boolean(
    toque.fbclid
    || toque.gclid
    || /^(paid|cpc|ppc)/i.test(toque.utm_medium || '')
    || /^meta$/i.test(toque.utm_source || ''),
  );
}

function mesmaCampanha(a, b) {
  return CHAVES_URL.every((k) => (a?.[k] || '') === (b?.[k] || ''));
}

/** @param {URLSearchParams} [searchParams] parâmetros da URL atual do app */
export function obterOrigemCadastro(searchParams) {
  const cookie = origemDoCookie();
  const primeiro = ehObjeto(cookie.primeiro_toque) ? { ...cookie.primeiro_toque } : null;
  let ultimoPago = ehObjeto(cookie.ultimo_toque_pago) ? { ...cookie.ultimo_toque_pago } : null;

  const daUrl = {};
  CHAVES_URL.forEach((k) => {
    const v = searchParams?.get(k);
    if (v) daUrl[k] = v.slice(0, 150);
  });
  const temUrl = Object.keys(daUrl).length > 0;
  // Os links do site repetem o último toque pago; só conta como novo toque se
  // for outra campanha (ex.: anúncio apontando direto para o app).
  if (temUrl && ehToquePago(daUrl) && !mesmaCampanha(daUrl, ultimoPago)) {
    ultimoPago = { ...daUrl, landing: 'app' };
  }

  const origem = {};
  if (primeiro) origem.primeiro_toque = primeiro;
  else if (temUrl) origem.primeiro_toque = { ...daUrl, landing: 'app' };
  if (ultimoPago) origem.ultimo_toque_pago = ultimoPago;

  const cta = searchParams?.get('cta');
  if (cta) origem.cta = cta.slice(0, 100);
  const fbc = lerCookie('_fbc');
  const fbp = lerCookie('_fbp');
  if (fbc) origem.fbc = fbc;
  if (fbp) origem.fbp = fbp;
  return Object.keys(origem).length ? origem : undefined;
}
